import { createSelector } from 'reselect';
import common from '../_common/selectors';

var getSubstate = function getSubstate(state) {
  return state.scopes;
};

var getAll = common.getAll(getSubstate);
var getAllAsObject = common.getAllAsObject(getSubstate);
var getActive = common.getActive(getSubstate);
var getActiveKey = common.getActiveKey(getSubstate);
var getByKey = common.getByKey(getSubstate);
var getByKeys = common.getByKeys(getSubstate);
var getByKeysAsObject = common.getByKeysAsObject(getSubstate);
var getDataByKey = common.getDataByKey(getSubstate);
var getEditedActive = common.getEditedActive(getSubstate);
var getEditedAll = common.getEditedAll(getSubstate);
var getEditedAllAsObject = common.getEditedAllAsObject(getSubstate);
var getEditedByKey = common.getEditedByKey(getSubstate);
var getEditedDataByKey = common.getEditedDataByKey(getSubstate);
var getEditedKeys = common.getEditedKeys(getSubstate);
var getDeletePermissionByKey = common.getDeletePermissionByKey(getSubstate);
var getUpdatePermissionByKey = common.getUpdatePermissionByKey(getSubstate);
var getUsedKeysForComponent = common.getUsedKeysForComponent(getSubstate);
var getIndexed = common.getIndexed(getSubstate);
var getStateToSave = common.getStateToSave(getSubstate);
var haveAllKeysRegisteredUse = common.haveAllKeysRegisteredUse(getSubstate);
var getActiveScopeConfiguration = createSelector([getActive], function (scope) {
  var _scope$data;

  return (scope === null || scope === void 0 ? void 0 : (_scope$data = scope.data) === null || _scope$data === void 0 ? void 0 : _scope$data.configuration) || null;
});
export default {
  getActive: getActive,
  getActiveKey: getActiveKey,
  getActiveScopeConfiguration: getActiveScopeConfiguration,
  getAll: getAll,
  getAllAsObject: getAllAsObject,
  getByKey: getByKey,
  getByKeys: getByKeys,
  getByKeysAsObject: getByKeysAsObject,
  getDataByKey: getDataByKey,
  getDeletePermissionByKey: getDeletePermissionByKey,
  getEditedActive: getEditedActive,
  getEditedAll: getEditedAll,
  getEditedAllAsObject: getEditedAllAsObject,
  getEditedByKey: getEditedByKey,
  getEditedDataByKey: getEditedDataByKey,
  getEditedKeys: getEditedKeys,
  getIndexed: getIndexed,
  getStateToSave: getStateToSave,
  getSubstate: getSubstate,
  getUpdatePermissionByKey: getUpdatePermissionByKey,
  getUsedKeysForComponent: getUsedKeysForComponent,
  haveAllKeysRegisteredUse: haveAllKeysRegisteredUse
};